import { Typography } from '@mui/material';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import UserMentionManager from '../../../helpers/utils/UserMentionManager';

const TypographyWithHighlightMentions = ({ text, ...props }) => {
  const userMentionManager = new UserMentionManager(); // Instanciation du Singleton
  const profile = useSelector((state) => state?.login?.profile);

  if (!text) {
    return text;
  }

  // Utilisation du Singleton pour transformer les IDs en noms d'utilisateur
  const modifiedText = userMentionManager.replaceIdsWithNames(text);

  // Mise en forme des mentions
  const highlightMentions = (content) => {
    const mentionRegex = /@(\w+)/g;
    const parts = content.split(mentionRegex);

    return parts.map((part, i) => {
      if (i % 2 === 1) {
        const isCurrentUser = part === profile?.email.split('@')[0];

        return (
          <Typography
            key={`mention-${i}`}
            component="span"
            color={isCurrentUser ? 'warning.main' : 'primary.main'}
            fontWeight="bold"
            sx={{ whiteSpace: 'pre-wrap' }}
          >
            @{part}
          </Typography>
        );
      }
      return <Fragment key={`text-${i}`}>{part}</Fragment>;
    });
  };

  return (
    <Typography
      {...props} // Priorité aux props externes
      sx={{ whiteSpace: 'break-spaces', ...props.sx }} // Fusion des sx
      component="span"
    >
      {highlightMentions(modifiedText)}
    </Typography>
  );
};

export default TypographyWithHighlightMentions;
